import React from "react";
import blinking from '../../Assets/images/boy-blink.png'
import openeyes from '../../Assets/images/boy.png'
import signature from '../../Assets/images/signature.png'
import { NavHashLink } from 'react-router-hash-link';
import './styles.scss'

const Nav = () => {    

    return (
        <nav>
            <div className="brand">
                <NavHashLink smooth to='/'>
                    <img className="top" src={ blinking } alt="blinking" />
                    <img src={ openeyes } alt="eyes open" />
                    <img id="logo" src={ signature } alt="" />
                </NavHashLink>
            </div>
            <div className="icons">
                <NavHashLink smooth to='/gallery'>
                    <div className="icon paint"></div>
                </NavHashLink>
                <NavHashLink smooth to='/contact'>
                    <div className="icon contact"></div>
                </NavHashLink>
                <a href="https://www.instagram.com/jaysaybay" target="_blank">
                    <div className="icon instagram"></div>
                </a>
                <NavHashLink smooth to='/map'>
                    <div className="icon map"></div>
                </NavHashLink>
            </div>
        </nav>
    )
}

export default Nav;